module.exports = __webpack_public_path__ + "static/media/europe-01.520ef62b.png";